import { observer } from "mobx-react-lite"
import controller from './coupon.controller'
import { useParams } from "react-router-dom";
import React, { useEffect } from "react";
import i from "../../../translations/i";
import { Titles } from "../../../layouts/Titles";
import {
  Select,
  Col,
  Divider,
  Input,
  Row,
  ColorPicker,
  Statistic,
  Button,
  InputNumber,
  DatePicker,
  TimePicker,
  Table,
  Modal,
  Typography,
  Segmented, Space, Tooltip, Upload
} from "antd";
import { runInAction } from "mobx";
import { DeleteOutlined, PlusOutlined, SettingOutlined } from "@ant-design/icons";
import { SwitchBlock } from "../../../components/SwitchBlock";
import dayjs from "dayjs";
import { SelectProducts } from "../../../helpers/select_entity/SelectEntity";
import __select from "../../../helpers/select_entity/__select.controller";
import { newDateTimeHelper } from "../../../modules/template/helpers/templateHelpers";
import __users from "../../users/users.controller";
import { CouponExUsers } from "./CouponExUsers";
import { CustomProductListsLayout } from "../../catalog/custom_product_lists/CustomProductListsLayout";
import { storeLocal } from "../../../helpers/stores";
import { __cpl } from "../../catalog/custom_product_lists/__cpl";
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { deleteFile } from "../../../helpers/files.controller";
import { RestrictedSelect } from "../../../components/access";
import { ErrorByPricingPlan } from "../../../components/ErrorByPricingPlan";

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("UTC")

export const Coupon = observer(() => {

  const { id }: any = useParams()

  useEffect(() => {
    controller.getCoupon(id)
    controller.getStatistics(id)
  }, [])

  const buttons = [
    { title: i.t('def:actions.backList'), href: `/shop/coupons`, type: 'dashed' },
    { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
  ]

  const columns = [
    {
      title: i.t('promo:use'),
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: i.t('promo:datetime'),
      dataIndex: 'date',
      key: 'date',
      render: (item: any) => newDateTimeHelper(item)
    },
    {
      title: i.t('def:Order_without_number'),
      dataIndex: 'orderid',
      key: 'orderid',
      render: (item: any) => <>{item > 0 && <a href={`/shop/orders/${item}`}>#{item}</a>}</>
    },
    {
      title: "",
      dataIndex: 'userid',
      key: 'userid',
      render: (item: any) => <>{item > 0 && <a href={`/users/${item}`}>
        {i.t('promo:user')}
      </a>}</>
    }
  ]



  return(
    <>
      <form onSubmit={(e) => controller.save(e)}>
        <Titles
          title={i.t('def:Coupon edit')}
          buttons={buttons}
        />

        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Segmented<string>
              options={[
                { label: i.t("def:main"), value: 'main' },
                { label: i.t("def:Coupon conditions"), value: 'conditions' },
                { label: i.t("def:Coupon users"), value: 'users', disabled: storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark') },
                { label: i.t("def:Coupon products"), value: 'products', disabled: storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark') },
                { label: i.t("def:Statistics"), value: 'statistics' }
              ]}
              value={controller.segment}
              onChange={(value) => runInAction(() => controller.segment = value)}
            />
          </Col>
          <Col span={24}>
            {controller.segment === 'main' &&
              <>
                <Row gutter={[20, 20]}>
                  <Divider />
                  <Col span={24}>
                    <SwitchBlock array={[
                      { label: i.t('def:active'), click: (e: any) => controller.item.enabled = e, value: controller.item.enabled },
                      { label: i.t('def:Coupon public'), click: (e: any) => controller.item.public = e, value: controller.item.public },
                      { label: i.t('def:Coupon prohibit_write_off'), click: (e: any) => controller.item.prohibit_write_off = e, value: controller.item.prohibit_write_off, block: 3 },
                      { label: i.t('def:Coupon disable_accrual'), click: (e: any) => controller.item.disable_accrual = e, value: controller.item.disable_accrual, block: 3 },
                    ]} />
                  </Col>
                  <Divider />
                  <Col span={12}>
                    <label>{i.t('def:Coupon code')}</label>
                    <Input
                      value={controller.item.code}
                      onChange={(e: any) => {
                        const inputValue = e.target.value.replace(/[-—]/g, '');
                        runInAction(() => controller.item.code = inputValue);
                      }}
                      required
                    />
                  </Col>
                  <Col span={12}>
                    <label>{i.t('def:Coupon name')}</label>
                    <Input
                      value={controller.item.name}
                      onChange={(e: any) => runInAction(() => controller.item.name = e.target.value)}
                      required
                    />
                  </Col>
                  <Col span={12}>
                    <label>{i.t('def:id_crm')}</label>
                    <Input
                      value={controller.item.id_crm}
                      onChange={(e: any) => runInAction(() => controller.item.id_crm = e.target.value)}
                    />
                  </Col>
                  <Col span={24}>
                    <label>{i.t('def:Coupon text')}</label>
                    <Input.TextArea
                      value={controller.item.text}
                      onChange={(e: any) => runInAction(() => controller.item.text = e.target.value)}
                      required
                    />
                  </Col>
                  <Col span={24}>
                    <label>{i.t('def:Coupon description')}</label>
                    <Input.TextArea
                      value={controller.item.description}
                      onChange={(e: any) => runInAction(() => controller.item.description = e.target.value)}
                    />
                  </Col>
                  <Col span={12}>
                    <label className="formLabel">{i.t('def:Select color')}</label>
                    <ColorPicker
                      value={`${controller.item.color_hex}`}
                      onChange={(e: any) => runInAction(() => controller.item.color_hex = e.toHexString())}
                    />
                  </Col>
                </Row>

                <CouponImage />
              </>
            }


            {controller.segment === 'conditions' &&
              <>
                <Row gutter={[20, 20]}>
                  <Col span={12}>
                    <label className="all-label">{i.t('def:Coupon date from')}</label>
                    <DatePicker
                      showTime
                      style={{ width: 100 + "%" }}
                      format="YYYY-MM-DD HH:mm"
                      minuteStep={10}
                      value={controller.item.datestart ? dayjs(controller.item.datestart * 1000) : null}
                      onChange={(time) => runInAction(() => controller.item.datestart = time.unix())}
                    />
                  </Col>
                  <Col span={12}>
                    <label className="all-label">{i.t('def:Coupon date to')}</label>
                    <DatePicker
                      showTime
                      style={{ width: 100 + "%" }}
                      format="YYYY-MM-DD HH:mm"
                      minuteStep={10}
                      value={controller.item.dateend ? dayjs(controller.item.dateend * 1000) : null}
                      onChange={(time) => runInAction(() => controller.item.dateend = time.unix())}
                    />
                  </Col>
                  <Divider />
                  <Col span={12}>
                    <label>{i.t('def:Coupon sum cart')}</label>
                    <InputNumber
                      value={controller.item.summcard}
                      onChange={(e: any) => runInAction(() => controller.item.summcard = e)}
                      style={{ width: `100%` }}
                    />
                  </Col>
                  <Divider />
                  <Col span={12}>
                    <label>{i.t('coupon:purposeLabel')}</label>
                    <RestrictedSelect
                      plan={3}
                      style={{ width: `100%` }}
                      value={controller.item.purpose}
                      onChange={(e: any) => runInAction(() => controller.item.purpose = e)}
                      options={[
                        { label: i.t('discount:noLimits'), value: null },
                        { label: i.t('coupon:deliveryOnly'), value: 'cart_delivery' },
                        { label: i.t('coupon:pickupOnly'), value: 'cart_pickup' },
                      ]}
                      checkBlackMark
                    />
                  </Col>
                  <Col span={12}>
                    <label>{i.t('coupon:warehousesLabel')}</label>
                    <RestrictedSelect
                      plan={3}
                      mode="multiple"
                      style={{ width: `100%` }}
                      placeholder={i.t('discount:warehousesPlaceholder')}
                      value={controller.item.warehouses.map((el: any) => el.warehouse_id)}
                      onChange={(e: any) => runInAction(() => controller.item.warehouses = e.map((warehouse_id: any) => ({ warehouse_id })))}
                      options={controller.data.warehouses.map((el: any) => ({
                        value: el.id,
                        label: el.name
                      }))}
                      checkBlackMark
                    />
                  </Col>
                  <Col span={12}>
                    <label>{i.t('coupon:platformsLabel')}</label>
                    <RestrictedSelect
                      plan={3}
                      mode="multiple"
                      style={{ width: `100%` }}
                      placeholder={i.t('coupon:platformsPlaceholder')}
                      value={controller.item.platforms.map((el: any) => el.platform)}
                      onChange={(e: any) => runInAction(() => controller.item.platforms = e.map((platform: any) => ({ platform })))}
                      options={[
                        { label: i.t('coupon:platformWeb'), value: 'web' },
                        { label: i.t('coupon:platformIphone'), value: 'iphone' },
                        { label: i.t('coupon:platformAndroid'), value: 'android' },
                      ]}
                      checkBlackMark
                    />
                  </Col>
                  <Col span={24}>
                    <label>{i.t('coupon:excludedDiscountsLabel')}</label>
                    <RestrictedSelect
                      plan={3}
                      mode="multiple"
                      style={{ width: `100%` }}
                      placeholder={i.t('coupon:excludedDiscountsPlaceholder')}
                      value={controller.item.discounts.map((el: any) => el.discount_id)}
                      onChange={(e: any) => runInAction(() => controller.item.discounts = e.map((discount_id: any) => ({ discount_id })))}
                      options={controller.data.discounts.map((el: any) => ({
                        value: el.id,
                        label: el.name
                      }))}
                      checkBlackMark
                    />
                  </Col>
                  <Divider />
                  <Col span={24}>
                    <label className="all-label">{i.t('coupon:scheduleLabel')}</label>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[20, 20]}>
                      <Col span={24}>
                        <ErrorByPricingPlan
                          content={
                            <Button onClick={() => controller.addDay()} disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}>{i.t('discount:addSchedule')}</Button>
                          }
                          plan={3}
                        />
                      </Col>
                      {controller.item.schedule.map((el: any, index: number) => (
                        <>
                          <Col span={7}>
                            <label>{i.t('discount:dayLabel')}</label>
                            <Select
                              options={[
                                { label: i.t('discount:weekdays.monday'), value: 1 },
                                { label: i.t('discount:weekdays.tuesday'), value: 2 },
                                { label: i.t('discount:weekdays.wednesday'), value: 3 },
                                { label: i.t('discount:weekdays.thursday'), value: 4 },
                                { label: i.t('discount:weekdays.friday'), value: 5 },
                                { label: i.t('discount:weekdays.saturday'), value: 6 },
                                { label: i.t('discount:weekdays.sunday'), value: 7 },
                              ]}
                              value={el.day}
                              onChange={(e: any) => runInAction(() => controller.item.schedule[index].day = e)}
                              style={{ width: '100%' }}
                            />
                          </Col>
                          <Col span={6}>
                            <label>{i.t('discount:timeStart')}</label>
                            <TimePicker
                              value={el.time_start != null ? dayjs().startOf("day").add(el.time_start, "second") : null}
                              onChange={(time: any) => {
                                const seconds = time.diff(dayjs().startOf("day"), "second")
                                runInAction(() => controller.item.schedule[index].time_start = seconds)
                              }}
                              format={"HH:mm"}
                              style={{ width: '100%' }}
                            />
                          </Col>
                          <Col span={6}>
                            <label>{i.t('discount:timeEnd')}</label>
                            <TimePicker
                              value={el.time_end != null ? dayjs().startOf("day").add(el.time_end, "second") : null}
                              onChange={(time: any) => {
                                const seconds = time.diff(dayjs().startOf("day"), "second")
                                runInAction(() => controller.item.schedule[index].time_end = seconds)
                              }}
                              format={"HH:mm"}
                              style={{ width: '100%' }}
                            />
                          </Col>
                          <Col span={5}>
                            <Button
                              type="dashed"
                              shape="circle"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={() => controller.deleteSchedule(index)}
                            />
                          </Col>
                        </>
                      ))}
                    </Row>
                  </Col>
                  <Divider />
                  <Col span={24}>
                    <SwitchBlock array={[
                      { label: i.t('def:Coupon counts'), click: (e: any) => controller.item.nocount = e, value: controller.item.nocount },
                      { label: i.t('def:Coupon birthday'), click: (e: any) => controller.item.birthday = e, value: controller.item.birthday, block: 2 },
                      { label: i.t('def:Coupon one to user'), click: (e: any) => controller.item.onetouser = e, value: controller.item.onetouser },
                      { label: i.t('def:Coupon first order'), click: (e: any) => controller.item.firstorder = e, value: controller.item.firstorder },
                    ]} />
                  </Col>
                  {controller.item.birthday ?
                    <Col span={24}>
                      <label>{i.t('def:Coupon birthday days')}</label>
                      <InputNumber
                        value={controller.item.birthday_limit}
                        onChange={(e: any) => runInAction(() => controller.item.birthday_limit = e)}
                      />
                    </Col> : <></>
                  }
                  {!controller.item.nocount
                    ? <>
                      <Col span={12}>
                        <label>{i.t('def:Count all coupon')}</label>
                        <InputNumber
                          value={controller.item.countall}
                          onChange={(e: any) => runInAction(() => controller.item.countall = e)}
                          style={{ width: `100%` }}
                        />
                      </Col>
                      <Col span={12}>
                        <label>{i.t('def:Count coupon')}</label>
                        <InputNumber
                          value={controller.item.count}
                          onChange={(e: any) => runInAction(() => controller.item.count = e)}
                          style={{ width: `100%` }}
                        />
                      </Col>
                    </>
                    : <>
                    </>
                  }

                  <Divider />
                  <Col span={12}>
                    <label>{i.t('def:Select type coupon')}</label>
                    <Select
                      options={[
                        { label: i.t('def:Fix discount'), value: 0 },
                        { label: i.t('def:Percent discount'), value: 1 },
                        { label: i.t('def:Gift to order'), value: 2, disabled: storeLocal.get('pricing_plan') < 1 },
                      ]}
                      style={{ width: `100%` }}
                      value={controller.item.type}
                      onChange={(e: any) => runInAction(() => controller.item.type = e)}
                    />
                  </Col>
                  <Col span={12}>
                    <label>{i.t('def:Coupon value')}</label>
                    <InputNumber
                      suffix={controller.item.type === 1 ? '%' : null}
                      value={controller.item.value}
                      onChange={(e: any) => runInAction(() => controller.item.value = e)}
                      style={{ width: `100%` }}
                      disabled={controller.item.type === 2}
                    />
                  </Col>
                  {controller.item.type !== 2 &&
                    <Col span={24}>
                      <SwitchBlock array={[
                        { label: i.t('def:Coupon apply_old_price'), click: (e: any) => controller.item.apply_old_price = e, value: controller.item.apply_old_price ?? true, block: 3 },
                      ]} />
                    </Col>
                  }
                  <Divider />
                  {controller.item.type === 2 &&
                    <CouponGifts />
                  }
                </Row>
              </>
            }

            {controller.segment === 'users' &&
              <>
                <Row gutter={[20, 20]}>
                  <Col span={24}>
                    <CouponExUsers />
                  </Col>
                </Row>
              </>
            }

            {controller.segment === 'products' &&
              <>
                <Row gutter={[20, 20]}>
                  <Col span={24}>
                    <label className="all-label">{i.t('def:Coupon select products')}</label>

                    <SelectedLists />
                    <br/><br/>

                    <CustomProductListsLayout
                      setFunction={(e: any) => {
                        if(__cpl.selectedLists.findIndex((el: any) => el === e) > -1)
                          controller.item.custom_list = controller.item.custom_list.filter((el: any) => el.id !== e)
                      }}
                    />
                  </Col>
                </Row>
              </>
            }

            {controller.segment === 'statistics' &&
              <>
                <Row gutter={[20, 20]}>
                  <Col span={24}>
                    <Statistic
                      title={i.t('def:Number of uses')}
                      value={controller.item.countHistory ?? 0}
                      precision={0}
                    />
                  </Col>
                  <Col span={24}>
                    <Row gutter={[20, 20]}>
                      <Col span={24}>
                        <DatePicker.RangePicker
                          format="DD.MM.YYYY"
                          onChange={(e: any, ee: any) => {
                            console.log(ee[0], ee[1])
                            controller.statistics.filter.date_from = ee[0]
                            controller.statistics.filter.date_to = ee[1]
                            controller.getStatistics(id)
                          }}
                          style={{ width: `100%` }}
                          // value={controller.filter.from ? [dayjs(controller.filter.from*1000).tz("UTC"), dayjs(controller.filter.to*1000).tz("UTC")] : null}
                        />
                      </Col>
                    </Row>
                    <Table
                      columns={columns}
                      dataSource={controller.statistics.data}
                      pagination={{
                        total: controller.statistics.total,
                        current: controller.statistics.page,
                        onChange: (e: any) => controller.onChangePageStatistics(e, id)
                      }}
                    />
                  </Col>
                </Row>
              </>
            }
          </Col>
        </Row>
      </form>

    </>
  )
})

const CouponGifts = observer(() => {

  return(
    <>
      <Col span={24}>
        <label className="all-label">{i.t('coupon:giftsLabel')}</label>
      </Col>
      <Col span={24}>
        <Button type="dashed" onClick={() => controller.openGiftModal()}>{i.t('discount:selectProducts')}</Button>
      </Col>
      {controller.item.gifts.length > 0 &&
        <Col span={24}>
          <Row gutter={[15, 15]}>
            <Col span={24}>
              <Row gutter={[15, 15]}>
                <Col span={2}><Typography.Text>ID</Typography.Text></Col>
                <Col span={4}><Typography.Text>{i.t('discount:tableImage')}</Typography.Text></Col>
                <Col span={6}><Typography.Text>{i.t('def:name')}</Typography.Text></Col>
                <Col span={4}><Typography.Text>{i.t('discount:tableQuantity')}</Typography.Text></Col>
                <Col span={6}><Typography.Text>{i.t('discount:tablePricePerItem')}</Typography.Text></Col>
                <Col span={2}></Col>
              </Row>
            </Col>
            {controller.item.gifts.map((gift: any, index: number) => (
              <Col span={24} key={`coupon_gift_${index}`}>
                <Divider dashed />
                <Row justify="space-around" align="middle" gutter={[15, 15]}>
                  <Col span={2}>
                    <a href={`/shop/catalog/product/${gift.product_id}`} target="_blank">{gift.product_id}</a>
                  </Col>
                  <Col span={4}>
                    {gift.product && gift.product.image ? <img src={gift.product.image.path} alt="" width="60px" /> : <></>}
                  </Col>
                  <Col span={6}>
                    {gift.product ? gift.product.name : i.t('discount:productNotExists')}
                  </Col>
                  <Col span={4}>
                    <ErrorByPricingPlan
                      plan={3}
                      content={
                        <InputNumber
                          style={{ width: '100%' }}
                          value={gift.count}
                          onChange={(e: any) => runInAction(() => controller.item.gifts[index].count = e)}
                          disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}
                        />
                      }
                    />
                  </Col>
                  <Col span={6}>
                    <ErrorByPricingPlan
                      plan={3}
                      content={
                        <InputNumber
                          style={{ width: '100%' }}
                          value={gift.price}
                          onChange={(e: any) => runInAction(() => controller.item.gifts[index].price = e)}
                          disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}
                        />
                      }
                    />
                  </Col>
                  <Col span={2}>
                    <Button
                      icon={<DeleteOutlined />}
                      shape="circle"
                      type="dashed"
                      danger
                      onClick={() => controller.deleteGift(index)}
                    />
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </Col>
      }

      <Modal
        title={i.t('discount:selectProductsTitle')}
        open={controller.modalGiftOpened}
        footer={null}
        onCancel={() => controller.closeGiftModal()}
        width={1000}
        centered={true}
        maskClosable={false}
      >
        <SelectProducts
          elementID={__select.select.value_array}
          returnFunction={(e: any) => controller.addGift(e)}
          visible={false}
        />
      </Modal>
    </>
  )
})

const SelectedLists = observer(() => {

  const columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id'
    },
    {
      title: i.t('def:name'),
      dataIndex: 'name',
      key: 'name'
    },
    {
      key: 'actions',
      render: (record: any) => (
        <>
          <Button
            type={__cpl.selectedLists.findIndex((el: any) => el === record.id) > -1 ? 'primary' : 'dashed'}
            onClick={() => {
              if(__cpl.selectedLists.findIndex((el: any) => el === record.id) > -1) {
                controller.item.custom_list = controller.item.custom_list.filter((el: any) => el.id !== record.id);
              }

              __cpl.selectList(record.id, true)
            }}
          >
            {__cpl.selectedLists.findIndex((el: any) => el === record.id) > -1 ? i.t('def:selected') : i.t('def:select')}
          </Button>
        </>
      )
    }
  ]

  return(
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <label className="all-label">{i.t('def:Selected lists')}</label>
        </Col>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={controller.item.custom_list}
            rowKey="id"
            size="small"
            pagination={false}
          />
        </Col>
      </Row>
    </>
  )
})


export const CouponImage = observer(() => {

  return(
    <>
      <Divider />
      <Col span={24}>
        <label>{i.t('def:image.image')}</label>
        <br/><br/>
      </Col>
      <Col span={24}>
        <label>{i.t('coupon:imageDisplayTypeLabel')}</label>
        <Select
          value={controller.item.coupon_image_view_type}
          options={[
            { label: i.t('coupon:textOverPhoto'), value: 0 },
            { label: i.t('coupon:textBelowPhoto'), value: 1 },
          ]}
          style={{width: `100%`}}
          onChange={(e) => controller.item.coupon_image_view_type = e}
        />
        <br/><br/>
      </Col>
      <Col span={24}>
        {controller.item.image
          ? <Row gutter={[10, 10]}>
            <Col xs={24}>
              <img src={controller.item.image.base + controller.item.image.uri} alt='' style={{maxWidth: '250px'}}/>
            </Col>
            <Col xs={24}>
              <Button
                onClick={() => {
                  deleteFile(controller.item.image.id)
                  controller.item.image = null
                }}
              >
                {i.t('def:deletePicture')}
              </Button>
            </Col>
          </Row>
          : <></>
        }


        <Upload
          beforeUpload={(info) => {
            controller.upload(info)
            return false
          }}
          listType="picture-card"
          className="photo-uploader"
          maxCount={1}
        >
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>{i.t('def:image.upload')}</div>
          </div>
        </Upload>
      </Col>
      <Col span={24}>
        {/*<label>{i.t('def:Short text')}</label>*/}
        {/*<Input.TextArea*/}
        {/*  placeholder={i.t('def:Short text')}*/}
        {/*  value={controller.item.short_description}*/}
        {/*  onChange={(e) => runInAction(() => controller.item.short_description = e.target.value)}*/}
        {/*/>*/}
      </Col>
    </>
  )
})